export default "__VITE_ASSET__aRjJK0gn__"